export default __webpack_public_path__ + "static/media/business-model-lean-canvas.1c85da1a.svg";